module.exports = __webpack_public_path__ + "media/images/gingerbread-1a0746e2764d77e8e19b18dd9bfd276b.png";